<template>
  <div class="header">
    <div class="header-img">
      <img :src="iconlogo"/>
    </div>
    <div class="header-bar">
      <div class="progress-bar">
        <div class="progress" :style="{width: progressbarWidth}">
        <!-- <div class="progress"> -->
        </div>
      </div>
    </div>
    <div class="header-amount">
      <p class="progress-percentage">
        {{progressbarWidth}}
        </p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProgressIndicator',

  props: {
    steps: Number,
    currentStep: Number,
  },

  data() {
    return {
      iconlogo: require('@/assets/mep-logo.png'),
    };
  },

  computed: {
    progressbarWidth() {
      return `${(this.currentStep / this.steps) * 100}%`;
    },
  },
});
</script>

<style lang="scss" scoped>
.primary {
  color: var(--color-primary);
}
.header {
  display: flex;
}

.header-img {
  width: 60px;
  height: 60px;
  display: inline-block;
}
.header-bar {
  height: 60px;
  width: calc(100% - 110px);
  padding: 25px 15px;
  display: inline-block;
}
.header-amount {
  color: var(--color-primary);
  width: 50px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  display: inline-block;
}

.progress-percentage {
  font-size: 18px;
  margin: 0;
  color: var(--font-color-light);
}

.progress-bar {
  height: 10px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.2);
}

.progress {
  height: 10px;
  background-color: var(--color-primary);
}
</style>
